import { combinedStyleSelector, createShallowEqualSelector, getColorSelector } from "@client/selectors";

export const makeBodyStyleSelector = (target: string, prefix?: string) => {
  const styleSelector = combinedStyleSelector(target, ["padding"], prefix);

  return createShallowEqualSelector(
    [styleSelector],
    (style): React.CSSProperties => ({
      ...style,
      display: "flex",
      flexDirection: "column",
      gap: "8px"
    })
  );
};

export const makeStyleSelector = (target: string, prefix?: string) => {
  const backgroundColorSelector = getColorSelector(target, "backgroundColor", prefix);
  const styleSelector = combinedStyleSelector(target, ["boxShadow", "border"], prefix);

  return createShallowEqualSelector(
    [backgroundColorSelector, styleSelector],
    (backgroundColor, style): React.CSSProperties => {
      return {
        boxShadow: "unset",
        backgroundColor,
        ...style
      };
    }
  );
};
